import { CONST } from '../utils/constants';
import DateUtils from '../utils/dateUtils';

export interface InvoiceRun {
  id: string; // System.Guid
  startDate: string; // System.DateTime
  includesMonthlyInvoices: boolean;
  includesQuarterlyInvoices: boolean;
  includesHalfYearlyInvoices: boolean;
  includesYearlyInvoices: boolean;
  runDateTime: string; // System.DateTime
  runByEmployeeId?: string; // System.Guid
  runByEmployeeFullName?: string;
  invoiceCount: number;
  companyId: string; // System.Guid
}

export interface Value {
  value: InvoiceRun[];
  '@odata.context'?: string | undefined;
  '@odata.count'?: number | undefined;
}

function toAPI(data: Partial<InvoiceRun>): any {
  return {
    Id: data?.id ?? undefined,
    StartDate: data?.startDate ?? DateUtils.getTodayDateAsIsoString(),
    IncludesMonthlyInvoices: data?.includesMonthlyInvoices ?? false,
    IncludesQuarterlyInvoices: data?.includesQuarterlyInvoices ?? false,
    IncludesHalfYearlyInvoices: data?.includesHalfYearlyInvoices ?? false,
    IncludesYearlyInvoices: data?.includesYearlyInvoices ?? false,
    RunDateTime: data?.runDateTime ?? new Date().toISOString(),
    RunByEmployeeId: data?.runByEmployeeId ?? undefined,
    CompanyId: data?.companyId ?? CONST.emptyGuid,
  };
}

function parse(data: Partial<InvoiceRun>): InvoiceRun {
  return {
    id: data?.id ?? CONST.emptyGuid,
    startDate: data?.startDate ?? DateUtils.getTodayDateAsIsoString(),
    includesMonthlyInvoices: data?.includesMonthlyInvoices ?? false,
    includesQuarterlyInvoices: data?.includesQuarterlyInvoices ?? false,
    includesHalfYearlyInvoices: data?.includesHalfYearlyInvoices ?? false,
    includesYearlyInvoices: data?.includesYearlyInvoices ?? false,
    runDateTime: data?.runDateTime ?? new Date().toISOString(),
    runByEmployeeId: data?.runByEmployeeId ?? undefined,
    runByEmployeeFullName: data?.runByEmployeeFullName ?? undefined,
    invoiceCount: data?.invoiceCount ?? 0,
    companyId: data?.companyId ?? CONST.emptyGuid,
  };
}

export default {
  parse,
  toAPI,
};
